import { useTranslation } from "react-i18next";
import {
  Box,
  Container,
  Stack,
  Heading,
  Text,
  Divider,
} from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

export default function Overview() {
  const mainColor = "#000"; 
  const accentColor = "#c6a664"; 
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const aboutData = t("about", { returnObjects: true });

  return (
    <Box
      id="overview"
      py={{ base: 20, md: 28 }}
      px={{ base: 6, md: 10 }}
      dir={isArabic ? "rtl" : "ltr"}
      bg="white"
      color={mainColor}
      textAlign="center"   
      overflow="hidden"
      position="relative"
    >
      <Container maxW="6xl" position="relative" zIndex={1}>
        <Stack
          direction="column"
          spacing={10}
          align="center"   
          justify="center"  
        >
          {/* Text Block */}
          <MotionBox
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            viewport={{ once: true }}
            maxW="900px"
            mx="auto"       
          >
            <Heading
              as="h2"
              fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
              fontWeight="bold"
              mb={4}
              color={mainColor}
            >
              {aboutData?.title ||
                (isArabic
                  ? "عن شركة الفا المتحدة للاستثمار"
                  : "About Alpha United Investment")}
            </Heading>

            <Divider
              borderColor={accentColor}
              borderWidth="2px"
              w="80px"
              mx="auto"
              mb={6}
            />

            <Text
              fontSize={{ base: "md", md: "lg" }}
              lineHeight="1.9"
              color="gray.700"
              mx="auto"
              maxW="800px"
            >
              {aboutData?.description ||
                (isArabic
                  ? "تأسست شركة الفا المتحدة للاستثمار في عام 2021 كشركة قابضة تهدف إلى إدارة وتطوير أعمال متنوعة في مختلف القطاعات. تركز الشركة على تحقيق النمو المستدام من خلال استثمارات استراتيجية مبتكرة"
                  : "Alpha United Investment Company was founded in 2021 as a holding company focused on managing and growing diversified business ventures through innovative, sustainable strategies")}
            </Text>
          </MotionBox>
        </Stack>
      </Container>

      {/* Decorative gold line */}
      <Box
        position="absolute"
        bottom={0}
        left="50%"
        transform="translateX(-50%)"
        w="60%"
        h="2px"
        bgGradient={`linear(to-r, transparent, ${accentColor}, transparent)`}
        opacity={0.4}
      />
    </Box>
  );
}
